var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16663 9.14943C9.16663 8.6892 9.53972 8.3161 9.99996 8.3161C10.4602 8.3161 10.8333 8.6892 10.8333 9.14943L10.8333 14.1494C10.8333 14.6097 10.4602 14.9828 9.99996 14.9828C9.53972 14.9828 9.16663 14.6097 9.16663 14.1494L9.16663 9.14943Z",
    fill: "#7E8A96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 5.04258C9.53972 5.04258 9.16663 5.41568 9.16663 5.87592C9.16663 6.33615 9.53972 6.70925 9.99996 6.70925C10.4602 6.70925 10.8333 6.33615 10.8333 5.87592C10.8333 5.41568 10.4602 5.04258 9.99996 5.04258Z",
    fill: "#7E8A96"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99996 1.66663C5.39759 1.66663 1.66663 5.39759 1.66663 9.99996C1.66663 14.6023 5.39759 18.3333 9.99996 18.3333C14.6023 18.3333 18.3333 14.6023 18.3333 9.99996C18.3333 5.39759 14.6023 1.66663 9.99996 1.66663ZM3.33329 9.99996C3.33329 13.6819 6.31806 16.6666 9.99996 16.6666C13.6819 16.6666 16.6666 13.6819 16.6666 9.99996C16.6666 6.31806 13.6819 3.33329 9.99996 3.33329C6.31806 3.33329 3.33329 6.31806 3.33329 9.99996Z",
    fill: "#7E8A96"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoGrey);
export default __webpack_public_path__ + "static/media/info-grey.255aa3b3.svg";
export { ForwardRef as ReactComponent };